import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAutoPickStrategy } from '~/services/contests/contests.service.api';

export const useUpdateAutoPickStrategy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ contestId, strategy }: { contestId: string; strategy: string }) =>
      updateAutoPickStrategy(contestId, { strategy }),
    onSuccess: (_, { contestId }) => {
      queryClient.invalidateQueries({
        queryKey: ['auto-pick-strategy', contestId],
      });
    },
  });
};
